'use strict';

/**
 * Management of the sticky footer to show the SAC number on desktop size.
 */
$(document).ready(function(){
    $("#footer-sticky-sac #fs-sac-button").click(function () {
        var imagesStickyFooter = $(this).find("svg");
        $("#info-sac-number").toggle(function () {
            if ($(this).is(":visible")) {
                pushDataLayerAssistancePhoneButton();
                $(imagesStickyFooter[0]).hide('fast', function(){
                    var closeSacImg = $(imagesStickyFooter[1]);
                    closeSacImg.show();
                    // Animage the close button from 45deg to 90deg
                    $({deg: 45}).animate({deg: 90}, {
                        duration: 500,
                        step: function(newD){
                            closeSacImg.css({transform: "rotate(" + newD + "deg)"});
                        }
                    });
                });
            } else {
                $(imagesStickyFooter[1]).hide();
                $(imagesStickyFooter[0]).fadeIn();
            }
        });
    });
    /* Delete Tap to call for desktop browser because it's open a new window */
    if(Revealizr.isDesktopDevice) {
        $("#footer-sticky-sac a[href*='tel:']").each(function () {
            $(this).replaceWith("<div>" + $( this ).text() + "</div>");
        });
    }
});